import { render, staticRenderFns } from "./index.vue?vue&type=template&id=458a2c8c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=458a2c8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458a2c8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('458a2c8c')) {
      api.createRecord('458a2c8c', component.options)
    } else {
      api.reload('458a2c8c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=458a2c8c&scoped=true&", function () {
      api.rerender('458a2c8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/liquidity/index.vue"
export default component.exports